import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Divider, IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from 'react-i18next';
import OutlinedButton from '../../shared/Button/customOutlinedButton';

type PopUpProps = {
  open: boolean;
  handleClose: () => void; 
  message: React.ReactNode; // <-- Change to allow JSX
  popupTitle: string; 
};


export default function TransactionDetailsPopUp(props: PopUpProps) {
    const { open, handleClose, message, popupTitle } = props;
    const { t } = useTranslation();
    const translate = t as (key: string) => string;

    return (
        <Dialog
            open={open}
            onClose={handleClose}  
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{ '& .MuiDialog-paper': { minWidth: '25%' } }}
        >
            <DialogTitle sx={{
                backgroundColor: "#059ca9",
                color: 'white',
                display: 'flex',
                justifyContent: 'space-between',
                padding: '10px 10px'
            }}>
                {popupTitle} 
               <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        color: "white",
                        padding: '0px'
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent style={{ paddingTop: '20px' }}>
                <DialogContentText
                    id="alert-dialog-description"
                    sx={{
                        whiteSpace: 'normal', // allow wrapping
                        overflowWrap: 'break-word', // break long words
                        wordBreak: 'break-word', // ensure long words wrap
                        fontSize: '1rem'
                    }}
                >
                    {message}
                </DialogContentText>
            </DialogContent>
            <Divider />
            <DialogActions>
                <DialogActions sx={{ padding: '0px' }}>  
                    <OutlinedButton onClick={handleClose}>
                        {translate('close')}
                    </OutlinedButton>
                </DialogActions>

            </DialogActions>
        </Dialog>
    );
}
